import { render, staticRenderFns } from "./valoare.vue?vue&type=template&id=41bbc90c&"
import script from "./valoare.vue?vue&type=script&lang=js&"
export * from "./valoare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports